<template>
  <div class="findcar-laptop" v-if="!isMain">
    <div class="findcar">
      <a name="find_computer"></a>
      <div class="title">
        <i class="findcar-icon-cat"
          ><i class="fa fa-car"></i>
          <i class="fa fa-search" aria-hidden="true"></i></i
        >FIND THE RIGHT CAR <br />COMPUTER YOU NEED:
      </div>
      <form action="#" method="get">
        <input type="hidden" name="act" value="viewCat" />
        <table>
          <tbody>
            <tr>
              <td class="search_td_item">
                <span class="search_label_item"
                  ><label for="make">Make:</label></span
                >
              </td>
              <td class="search_td_select">
                <select name="make" id="make" v-model="make_id">
                  <option value="">Select Make</option>
                  <option :value="make.id" v-for="make in makes" :key="make.id">
                    {{ capitalizeFirst(make.name) }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="search_td_item">
                <span class="search_label_item"
                  ><label for="model">Model:</label></span
                >
              </td>
              <td class="search_td_select" id="modelContainer">
                <select name="model" class="searchModels" v-model="model_id">
                  <option value="">Select Model</option>
                  <option
                    v-for="model in models"
                    :value="model.id"
                    :key="model.id"
                  >
                    {{ capitalizeFirst(model.name) }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="search_td_item">
                <span class="search_label_item"
                  ><label for="year">Year:</label></span
                >
              </td>
              <td class="search_td_select" id="yearContainer">
                <select name="year" class="searchYears" v-model="year_id">
                  <option value="">Select Year</option>
                  <option :value="year" v-for="year in years" :key="year">
                    {{ year }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="ta-r text-center">
                <input
                  type="button"
                  value="FIND COMPUTER"
                  class="findcompBtn"
                  name="cSearch"
                  @click="search"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
  <div class="col findcar" v-else>
    <h2 class="mobile-only">Select Your Vehicle</h2>
    <form action="index.php" method="get">
      <input type="hidden" name="act" value="viewCat" />
      <div class="form-group">
        <select style="" name="make" id="make-make" v-model="make_id">
          <option value="">Select Make</option>
          <option :value="make.id" v-for="make in makes" :key="make.id">
            {{ capitalizeFirst(make.name) }}
          </option>
        </select>
      </div>
      <div id="modelContainer1" class="form-group">
        <select
          style=""
          name="model"
          id="model-model"
          class="searchModels"
          v-model="model_id"
        >
          <option value="">Select Model</option>
          <option :value="model.id" v-for="model in models" :key="model.id">
            {{ capitalizeFirst(model.name) }}
          </option>
        </select>
      </div>
      <div id="yearContainer" class="form-group">
        <select
          style=""
          name="year"
          id="year-year"
          class="searchYears"
          v-model="year_id"
        >
          <option value="">Select Year</option>
          <option :value="year" v-for="year in years" :key="year">
            {{ year }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <input
          type="button"
          value="FIND COMPUTER"
          class="findcompBtn"
          name="cSearch"
          @click="search"
        />
      </div>
    </form>
  </div>
  <!-- end findcar -->
</template>

<script>
export default {
  props: ['isMain'],
  created() {
    axios.get('/api/catesearch/makes').then((res) => {
      this.makes = res.data
      this.makes.sort(this.sort)
    })
  },
  data() {
    return {
      makes: [],
      models: [],
      years: [],
      make_id: '',
      model_id: '',
      year_id: '',
    }
  },
  watch: {
    make_id: function (val) {
      const makes = this.makes.filter((make) => make.id == this.make_id)
      if (makes.length > 0) {
        this.models = makes[0].sub_category
        this.models.sort(this.sort)
      } else {
        this.models = []
      }
      this.model_id = ''
    },
    model_id: function (val) {
      this.years = []
      this.year_id = ''
      if (this.model_id) {
        axios
          .get(`/api/catesearch/years/${this.model_id}`)
          .then((res) => {
            this.years = res.data
          })
          .catch(_ => {})
      }
    },
  },
  methods: {
    capitalizeFirst(val) {
      val = val.replace('-', '')
      return val.replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase())
    },
    sort(a, b) {
      const aname = this.capitalizeFirst(a.name)
      const bname = this.capitalizeFirst(b.name)
      return aname > bname ? 1 : aname < bname ? -1 : 0;
    },
    search() {
      let searchStr = ''

      this.makes.forEach((make) => {
        if (make.id == this.make_id) {
          searchStr = 'make=' + make.id
        }
      })

      if (this.model_id) {
        this.models.forEach((model) => {
          if (model.id == this.model_id) {
            searchStr += '&model=' + model.id
          }
        })
      }

      if (this.year_id) {
        this.years.forEach((year) => {
          if (year == this.year_id) {
            searchStr += '&year=' + year
          }
        })
      }
      if (searchStr == '') {
        this.$message({
          message: 'To search for a product, you have to at least select MAKE.',
          type: 'warning',
        })
        return
      }
      return (location.href = '/search-products?' + searchStr)
    },
  },
}
</script>